import Vue from 'vue'
import { OPEN_ID, WX_USER, ACCESS_TOKEN, APPID } from "@/store/mutation-types"
import { postAction,getAction} from '@/api/manage'
import wx from 'weixin-js-sdk'
/**
 * 因为要求在所有入口页面都要掉是否实名认证的方法
 */
const OpenIdMixin = {

	data() {
		return {
			openId: '',
			sfSmrz: false,//是否实名认证
			code: '',
			object: {},
			roles:[],
		}
	},
	create() {


	},
	methods: {
		// enCodeLoginUrl(state) {
		// 	let redirectUrl = window.location.href;
		// 	var retUrl = encodeURIComponent(redirectUrl);
		// 	var url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + APPID
		// 		+ "&redirect_uri=" + retUrl
		// 		+ "&response_type=code&scope=snsapi_userinfo"
		// 		+ "&state=" + (state || '')
		// 		+ "&connect_redirect=1#wechat_redirect"

		// 	return url;
		// },
		// //微信登录
		// wx_login() {
		// 	// window.history.replaceState({}, '123', this.enCodeLoginUrl('fromLogin'));
		// 	window.location.replace(this.enCodeLoginUrl('fromLogin'));
		// },
		//有openId才能往下走
		initOpenId() {

			return new Promise((resolve, reject) => {
			
				let userInfo = Vue.ls.get(WX_USER);
				let detectAuthId = userInfo? userInfo.detectAuthId:'';
				this.code = this.getUrlCode().code;
				let state = this.getUrlCode().state;
				let oldCode = Vue.ls.get('code');

				if (this.code && oldCode != this.code) {//有code
					let params = { code: this.code }
					postAction('/sys/mlogin/wechart-mp/get/openid', params).then((res) => {
						if (res.success) {
							let obj = res.result;
							if (obj) {
								let token = obj.token;
								let openId = obj.openid;
								Vue.ls.set('code', this.code);
								Vue.ls.set(OPEN_ID, openId);
								Vue.ls.set(ACCESS_TOKEN, token);
								Vue.ls.set('roles', obj.roles);
								if (obj.SysUserWechatBind && obj.SysUserWechatBind.length > 0) {
									this.object = obj.SysUserWechatBind[0];
									Vue.ls.set(WX_USER, this.object);  
								}else{
									Vue.ls.remove(WX_USER);
								}
								resolve();
							}
						
						} else {
							reject();
						}
					//    this.xgAddr();	
					}).catch(error => {
						reject(error);
					})
				} else if (this.code == oldCode && detectAuthId) {//返回并且已经认证
					resolve();
				} else {
				let obj = this.getSmrzData();
					getAction('/system/sysuserwechatbind/query/by/id', {id:obj.id}).then((res) => {
						if (res.success) {
							let obj = res.result;
							if (obj) {
								Vue.ls.set(OPEN_ID, obj.openId);
								Vue.ls.set(WX_USER, obj);
								resolve();
							}
						} else {
							reject(error);
						}
					}).catch(error => {
						reject(error);
					})
				}

			})
		},

		isSmrz() {
			let object = Vue.ls.get(WX_USER, {});
			if (object&&object.detectAuthId){
				return true;
			}else{
				return false
			}
		},
		getSmrzData() {
			let object = Vue.ls.get(WX_USER, {});
			return object;
		},
		getUrlCode() {
			// 截取url中的code方法
			var url = location.search;
			var theRequest = new Object();
			if (url.indexOf("?") != -1) {
				var str = url.substr(1);
				var strs = str.split("&");
				for (var i = 0; i < strs.length; i++) {
					theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
				}
			}
			console.log(theRequest);
			return theRequest;
		},
		isIos() {//判断是IOS还是Android
			var userAgent = navigator.userAgent;
			var isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1; //android终端
			var isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
			if (isAndroid) {
				return false;
			} else if (isiOS) {
				return true;
			}
		},
		goBack() {
			wx.closeWindow();
		},
		xgAddr(){
			let redirectUrl = window.location.href;
		   let url = redirectUrl.replace('fromLogin','back');
			console.log(url);
			 window.history.replaceState("", "", url);
		   },
		// initPage(){
		// 	console.log(88888888);
		// 	if (this.isIos()) {
		// 		var isPageHide = false;
		// 		window.addEventListener('pageshow', function () {
		// 			if (isPageHide) {
		// 				console.log('333333');
		// 				// window.location.reload();
		// 			}
		// 		});
		// 		window.addEventListener('pagehide', function () {
		// 			isPageHide = true;
		// 			console.log('44444444');
		// 		});
		// 	} else {
		// 		window.addEventListener('pageshow', function () {
		// 			console.log('1111111');

		// 		});
		// 		window.addEventListener('pagehide', function () {
		// 			console.log('22222222');
		// 		});

		// 	}
		// }
	},
	// beforeRouteLeave(to, from, next) {
	//    console.log('11111111');
	// 	next() // 下一步
	// },
	// beforeRouteEnter(to, from, next) {
	// 	console.log('22222222');
	// 	 next() // 下一步
	//  },
	//  beforeRouteUpdate(to, from, next) {
	// 	console.log('33333333');
	// 	 next() // 下一步
	//  },
	// destroyed(){
	// 	console.log('销毁实力');
	// }
}

export default OpenIdMixin;
